export const GAME_PATH = 'desktop';

export const DEVELOPMENT_GAME_URL = 'http://localhost:8080';

export const LOCAL_DEV_LOBBY_URL = 'http://client.pragmaticplaylive.net';

export const MIN_WIDTH_BEFORE_MTB_SWITCH_TO_MOBILE = 1024;
export const MIN_HEIGHT_BEFORE_MTB_SWITCH_TO_MOBILE = 500;

export const LAUNCHER_BASE_WIDTH = 1920;

export const LAUNCHER_BASE_HEIGHT = 1080;

export const OPERATOR_GAME_IDS_TO_HIDE = [];
